<script>
import { AbstractListBox, SearchableOptionsMixin } from './commons';

export default AbstractListBox.extend({
  name: 'ClyListbox',
  mixins: [SearchableOptionsMixin],
  props: {
    searchable: { type: Boolean, default: false, required: false }, // override the mixin
    value: { type: [String, Number] },
  },
  computed: {
    searchedOptions() {
      return this.getMatching(this.options);
    },
  },
});
</script>
<template>
  <div
    style="height: 100%"
    class="cly-vue-listbox"
    tabindex="0"
    :class="topClasses"
    @mouseenter="handleHover"
    @mouseleave="handleBlur"
    @focus="handleHover"
    @blur="handleBlur"
  >
    <div
      v-if="searchable"
      class="cly-vue-listbox__header bu-p-3"
    >
      <form>
        <el-input
          v-model="searchQuery"
          :disabled="disabled"
          autocomplete="off"
          :placeholder="searchPlaceholder"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
          />
        </el-input>
      </form>
    </div>
    <vue-scroll
      v-if="searchedOptions.length > 0"
      :style="vueScrollStyle"
      :ops="scrollCfg"
    >
      <div
        :style="wrapperStyle"
        class="cly-vue-listbox__items-wrapper"
      >
        <div
          v-for="(option, idx) in searchedOptions"
          :key="'i' + idx + '.' + option.value"
          tabindex="0"
          class="text-medium font-weight-bold"
          :class="{'selected': value === option.value,
                   'hover': hovered === option.value,
                   'cly-vue-listbox__item': !option.group,
                   'cly-vue-listbox__group text-uppercase': option.group
          }"
          @focus="!option.group && handleItemHover(option)"
          @mouseenter="!option.group && handleItemHover(option)"
          @keyup.enter="!option.group && handleItemClick(option)"
          @click.stop="!option.group && handleItemClick(option)"
        >
          <div class="cly-vue-listbox__item-content">
            <div class="bu-level">
              <div class="bu-level-left">
                <div
                  v-if="!!$scopedSlots['option-prefix']"
                  class="cly-vue-listbox__item-prefix bu-mr-1"
                >
                  <slot
                    name="option-prefix"
                    v-bind="option"
                  />
                </div>
                <slot
                  name="option-label"
                  v-bind="option"
                >
                  <div
                    v-tooltip="option.label"
                    class="cly-vue-listbox__item-label"
                  >
                    {{ option.label }}
                  </div>
                </slot>
              </div>
              <div
                v-if="hasRemovableOptions || !!$scopedSlots['option-suffix']"
                class="bu-level-right"
              >
                <slot
                  class="cly-vue-listbox__item-suffix"
                  name="option-suffix"
                  v-bind="option"
                />
                <div
                  v-if="hasRemovableOptions"
                  class="cly-vue-listbox__remove-option"
                  @click.stop="onRemoveOption(option)"
                >
                  <i class="el-icon-close" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
    <div
      v-else
      class="cly-vue-listbox__no-data"
    >
      {{ noMatchFoundPlaceholder }}
    </div>
  </div>
</template>
